enum AppVersion {
    BASE = "BASE",
    FREE = "FREE",
    GLORY = "GLORY",
    PREMIUM = "PREMIUM",
    /* 从旧版本用户迁移过来的用户 */
    GLORY_V1 = "GLORY_V1",
}

export default AppVersion;
